import React from "react";
import { useTranslation } from "react-i18next";
import { ElementRoot } from "./ElementRoot.jsx";

export const LockedPreview = () => {
  const { t } = useTranslation();
  return (
    <ElementRoot loaded>
      <div className="ang_preview_message_wrapper">
        <div className="ang_preview_message_wrapper_inner">
          <div className="ang_preview_image ang_preview_image_locked" />
          <div className="ang_preview_message">
            <p>{t("File is locked.")}</p>
          </div>
        </div>
      </div>
    </ElementRoot>
  );
};
